import { useEffect, useRef } from 'react';

import { QueryKey, UseQueryResult, hashKey } from '@tanstack/react-query';

const useQueryErrorEffect = (query: UseQueryResult<unknown, unknown>, queryKey: QueryKey, onError: () => void) => {
  const { isError, errorUpdatedAt, isFetchedAfterMount } = query;
  const keyHash = hashKey(queryKey);
  const attached = useRef({ hash: '', at: 0 });
  const handledErrorAt = useRef(0);

  useEffect(() => {
    if (attached.current.hash !== keyHash) {
      attached.current = { hash: keyHash, at: Date.now() };
    }
    // resetQueries() (logout) resets isFetchedAfterMount, so also accept errors newer than the attach.
    const isNewError = isFetchedAfterMount || errorUpdatedAt > attached.current.at;
    if (!isError || !isNewError || errorUpdatedAt === handledErrorAt.current) return;
    handledErrorAt.current = errorUpdatedAt;
    onError();
  }, [isError, errorUpdatedAt, isFetchedAfterMount, keyHash, onError]);
};

export default useQueryErrorEffect;
